import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, A11y, Thumbs, EffectFade } from 'swiper';

SwiperCore.use([Autoplay, Navigation, Pagination, Scrollbar, A11y, Thumbs, EffectFade]);
